export default "__VITE_ASSET__DEjMN6Wh__"